import {useState,useRef} from "react";
import {useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useSelector,useDispatch } from "react-redux";
import axios from "axios";

import { Modal } from 'react-responsive-modal';
import './ServiceBottom.scss'
import { validEmail } from '../Common/regex.js';
import { getData, postData } from "../Services/APIService";
import config from "../Services/config.json";
import { updateCustomer } from './../../ReduxActions/customerAction';
import JButton from '../../components/Button/JButton';

const ServiceBottom= ({serviceType,step}) => {

    const dispatch = useDispatch();

    const [showPopupCover,setShowPopupCover] = useState(false);
    const [getChkArea,setChkArea] = useState(false);
    const [getChkModem,setChkModem] = useState(false);
    //const [getSelectedCode,setSelectedCode] = useState(0);
    const customer = useSelector(state => state.customer);
    const history = useHistory();
    const [bankresponse,setBankresponse]=useState(null);
    const [redirect,setRedirect]=useState(0);
    const bankForm = useRef(null);
    

    const handleChangeChkArea = () =>{
        setChkArea(!getChkArea);
    }

    const handleChangeChkModem = () =>{
        setChkModem(!getChkModem);
    }

    const handleNextStep = (e) =>{
        e.preventDefault();

        if(serviceType===1){//ADSL
            if(step === 1){
                if(customer.checkPhone === -1){
                    toast.error("وضعیت تلفن بررسی نشده است", {position: "bottom-left",closeOnClick: true});
                    return;
                }

                // if(customer.serviceCode === 0)
                //     history.push("/serviceShow");
                // else
                //     history.push("/equipmentShow");
                history.push("/serviceShow");
            }
            else if(step===2){
                if(customer.serviceCode===0){
                    toast.error("هیچ سرویسی انتخاب نشده است", {position: "bottom-left",closeOnClick: true});
                    return;
                }

                // history.push("/equipmentShow");
                
                history.push("/fillInfo");
            }
            else if(step===3){
                // if(customer.equipmentCode === 0 && !getChkModem){
                //     toast.error("باید تجهیزاتی انتخاب شود یا تیک گزینه مودم دارم زده شود", {position: "bottom-left",closeOnClick: true});
                //     return;
                // }

                // history.push("/fillInfo");
                const resu=checkFillInfo();
                if(resu)
                {
                    handleRegistering();
                }
            }
            else if(step===4){
                // const resu=checkFillInfo();
                // if(resu)
                // {
                //     handleRegistering();
                // }
                handlePayment();
            }
            else if(step == 5){
                handlePayment();
            }
        }
        else if(serviceType===2){//LTE
            if(step===1){
                // if(!getChkArea){
                //     toast.error("مناطق تحت پوشش را تیک نزده اید", {position: "bottom-left",closeOnClick: true});
                //     return;
                // }
                
                // if(!getChkModem && !customer.serviceWithModem){
                //     toast.error("تیک گزینه مودم دارم را نزده اید", {position: "bottom-left",closeOnClick: true});
                //     return;
                // }

                if(customer.serviceCode===0){
                    toast.error("هیچ سرویسی انتخاب نشده است", {position: "bottom-left",closeOnClick: true});
                    return;
                }

                history.push("/fillInfo");
            }
            else if(step===2){
                const resu=checkFillInfo();
                if(resu)
                {
                    handleRegistering();
                }
            }
            else if(step == 3){
                handlePayment();
            }
        }
        else if(serviceType===3){//Gaming
            if(step===1){
                // if(!getChkArea){
                //     toast.error("مناطق تحت پوشش را تیک نزده اید", {position: "bottom-left",closeOnClick: true});
                //     return;
                // }

                if(customer.serviceCode===0){
                    toast.error("هیچ سرویسی انتخاب نشده است", {position: "bottom-left",closeOnClick: true});
                    return;
                }

                history.push("/fillInfo");
            }
            else if(step===2){
                const resu=checkFillInfo();
                if(resu)
                {
                    handleRegistering();
                }
            }
            else if(step == 3){
                handlePayment();
            }
        }
    }

    const checkFillInfo = ()=>{
        //return true;

        if(customer.FillInfo===0){
            toast.error("همه فیلدهای ستاره دار باید پر شوند", {position: "bottom-left",closeOnClick: true});
            return false;
        }
        else if(customer.City === '0' || customer.City === 'undefined'){
            toast.error("شهر انتخاب نشده است", {position: "bottom-left",closeOnClick: true});
            return false;
        }
        else if(customer.SecurityCodeDone !=1 ){
            toast.error("کد امنیتی صحیح وارد نشده است", {position: "bottom-left",closeOnClick: true});
            return false;
        }
        else if (customer.MobileVerified != 1){
            toast.error("موبایل تایید نشده است", {position: "bottom-left",closeOnClick: true});
            return false;
        }
        else if (customer.Phone.length>0 && customer.Phone.length != 10){
            toast.error("شماره تلفن صحیح نیست، تلفن باید ده رقمی همراه با کد استان بدون صفر باشد", {position: "bottom-left",closeOnClick: true});
            return false;
        }
        else if (customer.Melli.length>0 && customer.Melli.length != 10){
            if(customer.Real === 1){
                toast.error("شماره ملی باید ده رقمی باشد", {position: "bottom-left",closeOnClick: true});
            }
            else{
                toast.error("شناسه ملی باید ده رقمی باشد", {position: "bottom-left",closeOnClick: true});
            }
            return false;
        }
        else if (customer.ZipCode.length> 0 && customer.ZipCode.length != 10){
            toast.error("کد پستی باید ده رقمی باشد", {position: "bottom-left",closeOnClick: true});
            return false
        }
        else if (customer.Email.length != 0 && !validEmail.test(customer.Email)){
            toast.error("ایمیل صحیح نمی باشد", {position: "bottom-left",closeOnClick: true});
            return false
        }
        else if (customer.Know == 0){
            toast.error("نحوه آشنایی را انتخاب کنید", {position: "bottom-left",closeOnClick: true});
            return false
        }

        return true;
    }

    const handlePayment= async (e) =>{
        // e.preventDefault();

        console.log("StoreLog: ","Paymenting");

        if(customer.PayWay === 1 && customer.Bank === 0){
            toast.error("لطفا بانک را انتخاب کنید",{position:'bottom-left',closeButton:true,closeOnClick:true});
            return;
        }

        var siteURL = window.location.protocol + '//' + window.location.host+'/callback';
        siteURL = siteURL.replace( /[.]/g,'__1__').replace(/[:]/g,'__2__').replace(/[/]/g,'__4__');
        var callbackURL=config.apiAddress+'/ChargeOnline/CheckTransaction?myurl='+siteURL;

        const info={
            CustomerCode:customer.CustomerCode,
            FactorCode:customer.FactorCode,
            MyLink:(typeof window !== 'undefined') ? window.location.protocol + '//' + window.location.host+"/callback":"",
            token: config.APIKey,
            PayWay:customer.PayWay,
            Bank:customer.Bank,
            CallBackURL:callbackURL,
            ServiceType:customer.serviceType
         };

        try{
            const {data}=await getData('store/paymentFactor',info);
            console.log("StoreLog: paymentFactor : ",data.link);

            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
            }
            else if (customer.PayWay === 1){
                if(data.Message === null || data.Message === ''){
                    dispatch(updateCustomer({RequestType:data.requestType,RequestData:data.Data,RequestLink:data.link}));
                    handleRedirecting(data)
                }
                else{
                    toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                }
            }
            else //پرداخت در محل
            {
                history.push("/callback");
            }
        }
        catch(ex){
            console.log("StoreError: ",ex.Message);
        }

    }

    const handleRedirecting = async (response) => {
        if(response.requestType==0){//GET
            window.open(response.link,"_self");
        }
        else if(response.requestType==1){//POST
            setBankresponse(response);
            setRedirect(1);
            await makeDelay(1000);
            setRedirect(2);
        }
        else if (response.requestType == 2) { // Form
            try {
            const html = response.Data.body;
            if (!html) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                return;
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const form = doc.forms[0];
            if (!form) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                return;
            }

            document.body.appendChild(form);
            form.submit();
            } catch (error) {
            console.error("Form handling error:", error);
            toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
            }
        }
    }

    function getCookie(name) {
        try {
        const match = document.cookie
            .split("; ")
            .find(row => row.startsWith(name + "="));

        if (!match) return null;

        const raw = match.split("=")[1];
        return decodeURIComponent(raw); // decode URL encoding
        } catch (err) {
        console.error("Failed to get cookie string:", err);
        return null;
        }
  }

    const handleRegistering = async () =>{
        console.log("StoreLog: ","Registering");

        const info={
            CustomerCode:customer.CustomerCode,
            FactorCode:customer.FactorCode,
            MyLink:'',
            token: config.APIKey,
            CustomerType:customer.serviceType,
            ServiceCode:customer.serviceCode,
            EquipmentCode:customer.equipmentCode,
            Real:customer.Real,
            Name:customer.Name,
            Family:customer.Family,
            Melli:customer.Melli,
            Mobile:customer.Mobile,
            Phone:customer.Phone,
            Email:customer.Email,
            ZipCode:customer.ZipCode,
            Address:customer.Address,
            BirthDate:customer.Year+'-'+customer.Month+'-'+customer.Day,
            Sex:customer.Sex,
            City:customer.City,
            Know:customer.Know,
            CompanyName:customer.CompanyName,
            Presenter:customer.Presenter,
            Cookie: getCookie("mahannet_visit_log"),
            Clue:true
            // SourceURL:localStorage.getItem('originalReferrer')??''
         };

        try{
            //const {data}=await sendData('store/registerCustomer',info);
            const {data}=await postData('store/registerCustomerPost',info);
            
            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else{
                if(customer.serviceType===1 && customer.checkPhone===0){//تحت پوشش نبوده است
                    setShowPopupCover(true);
                }
                else{
                    dispatch(updateCustomer({UserName:data.userName,Password:data.password,CustomerCode:data.customerCode,FactorCode:data.factorCode}));
                    // if(serviceType!=3)
                        history.push("/payment?serviceCode="+customer.serviceCode+"&customerCode="+data.customerCode+"&factorCode="+data.factorCode+"&serviceType="+customer.serviceType);
                    // else
                        // history.push("/finalpage");
                }
            }
        }
        catch(ex){
            console.log("StoreError: ",ex.Message);
        }
    }

    const handlePrevStep= (e) =>{
        e.preventDefault();
        
        if(serviceType===1){
            if(step===2){
                history.push("/checkPhone");
            }
            else if(step===3){
                history.push("/serviceShow");
            }
            else if(step===4){
                // history.push("/equipmentShow");
                history.push("/fillInfo");
            }
            else if(step===5){
                // history.push("/fillInfo");
            }
        }
        else{
            if(step===2){
                history.push("/serviceShow");
            }
            else if(step===3){
                history.push("/fillInfo");
            }
        }
    }

    const makeDelay=(ms) => new Promise(
        resolve => setTimeout(resolve, ms)
    );
    
    return (
        <>
        {bankresponse && bankresponse.requestType==1 && <form id='bankForm' ref={bankForm} method="POST" action={bankresponse.link}>{Object.keys(bankresponse.Data).map(name => (<input type="hidden" name={name} value={(bankresponse).Data[name]} />))}</form>}
        {redirect == 2 && (bankForm.current).submit() }
        <Modal classNames={{closeIcon:"modalClose",modal:"modal"}} open={showPopupCover} onClose={() => setShowPopupCover(false)} center>
            <div className="modalIconP">
              <div className="modalIcon colorRed borderRed">
                <label className="fa fa-info"></label>
              </div>
            </div>
            <label className="modalTitle">مشتری گرامی در حال حاضر امکان ارائه سرویس بر روی شماره تلفن ثابت وارد شده وجود ندارد</label>
            <div className="modalBody">
                <label className="modalLabel fontBold">
                    برای رفع نیاز خود از سایر سرویس های اینترنت پر سرعت ماهان نت استفاده کنید
                </label>
                
                <div className="btnProfileLogin">
                    <a href="/">سرویس های دیگر</a>
                </div>
            </div>
        </Modal>
        <div className="selectServiceBottom">
            <div className="nextPrevStep0">
                {/* <div className={`btnStep ${((customer.checkPhone != 0 && customer.checkPhone != 2 ) || serviceType!=1) ? "nextStep" : "nextStepDisable"}`} onClick={handleNextStep}>
                    {
                        (serviceType === 1 && step<5) || (serviceType != 1 && step<3) ?
                        <>
                        <div className="fa fa-arrow-circle-left"></div>
                        <span>
                            مرحله بعد
                        </span>
                        </>
                        :
                        <span>
                            پرداخت و ثبت نهایی سفارش
                        </span>
                    }
                </div> */}
                <div className="btnStep">
                    <JButton handleClick={handleNextStep} title={(serviceType === 1 && step<4) || (serviceType != 1 && step<3) ?  "مرحله بعد" : (customer.PayWay===1 ? "پرداخت و ثبت سفارش" : "ثبت سفارش")} rightIcon={(serviceType === 1 && step<4) || (serviceType != 1 && step<3) ? "fa fa-arrow-circle-left" : ""} type={(customer.checkPhone != -1 || serviceType!=1) ? "LTE" : "Disabled"} noSize={true} />
                </div>
            </div>
            <div className="stepEmpty"></div>
            {/* {serviceType === 2 && step===1 ?
                <>
                <div className="coverArea">
                    <div onClick={handleChangeChkArea} className={`${ getChkArea ? "activeChk" : "normalChk"}`}><span className="fa fa-check"></span></div>
                    <label>مناطق تحت پوشش TD-LTE ماهان نت را بررسی کرده و تایید می کنم در محدود پوشش دهی قرار دارم.</label>
                </div>
                <div className={`hasModem${customer.serviceWithModem ? " hasModemDisabled" : ""}`}>
                    <div onClick={handleChangeChkModem} className={`${ getChkModem || customer.serviceWithModem ? "activeChk" : "normalChk"}`}><span className="fa fa-check"></span></div>
                    <label>مودم LTE دارم</label>
                </div>
                </>
                :(
                    serviceType === 3 && step === 1 ?
                    <div className="coverArea">
                        <div onClick={handleChangeChkArea} className={`${ getChkArea ? "activeChk" : "normalChk"}`}><span className="fa fa-check"></span></div>
                        <label>مناطق تحت پوشش TD-LTE ماهان نت را بررسی کرده و تایید می کنم در محدود پوشش دهی قرار دارم.</label>
                    </div>
                    :null
                )
            }

            {
                serviceType === 1 && step===3 ?
                <div className="hasModem">
                    <div onClick={handleChangeChkModem} className={`${ getChkModem || customer.serviceWithModem  ? "activeChk" : "normalChk"}`}><span className="fa fa-check"></span></div>
                    <label>مودم ADSL دارم</label>
                </div>
                : null
            } */}

            {step>1 ?
            <div className="nextPrevStep">
                {/* <div className="btnStep prevStep" onClick={handlePrevStep}>
                    <span>
                        مرحله قبل
                    </span>
                    <div className="fa fa-arrow-circle-right"></div>
                </div> */}
                <div className="btnStep">
                    <JButton handleClick={handlePrevStep} title={"مرحله قبل"} leftIcon={"fa fa-arrow-circle-right"} type={""} noSize={true}/>
                </div>
            </div>
            :null}
        </div>
        <div className="nextDivi">
            <JButton handleClick={handleNextStep} title={(serviceType === 1 && step<4) || (serviceType != 1 && step<3) ?  "مرحله بعد" : (customer.PayWay===1 ? "پرداخت و ثبت سفارش" : "ثبت سفارش")} rightIcon={(serviceType === 1 && step<4) || (serviceType != 1 && step<3) ? "fa fa-arrow-circle-left" : ""} type={(customer.checkPhone != -1 || serviceType!=1) ? "LTE" : "Hidden"} noSize={true} />
        </div>
        </>
    );
}

export default ServiceBottom;
